// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"styles_input-wrapper__3TIZK"};